// ==============================================================================================

import fetchHandler from '../../api/Handler';

export const AuthenticationAPI = {
	tokenRefreshInterval: null as NodeJS.Timeout | null,
	async Login(data: any, slug: any): Promise<{ error?: any; data?: any } | null> {
		try {
			const response = await fetchHandler({
				method: 'POST',
				endpoint: `vendors/${slug}/login-otp`,
				data,
			});
			if (response.isError) {
				return { error: response.data };
			}

			return { data: response };
		} catch (error) {
			console.error('Login error:', error);
			return { error: 'An unexpected error occurred.' };
		}
	},
	async SendOtp(
		data: any,
		// tokenId: string
		slug: any
	): Promise<{ error?: any; data?: any } | null> {
		try {
			console.log(slug, 'slug');
			const response = await fetchHandler({
				method: 'POST',
				endpoint: `vendors/${slug}/login`,
				data,
			});
			if (response.isError) {
				return { error: response.data };
			} else {
			}

			return { data: response };
		} catch (error) {
			console.error('Reset password error:', error);
			return { error: 'An unexpected error occurred.' };
		}
	},
	async ResendOtp(
		data: any
		// tokenId: string
	): Promise<{ error?: any; data?: any } | null> {
		try {
			const response = await fetchHandler({
				method: 'POST',
				endpoint: `/vendors/send-otp`,
				data,
			});
			if (response.isError) {
				return { error: response.data };
			}

			return { data: response };
		} catch (error) {
			console.error('Reset password error:', error);
			return { error: 'An unexpected error occurred.' };
		}
	},
};
